import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext, useRoute } from "@bcm-dev/bcms-vite";
import { PageContainer, PageContentView, WidgetContainer, WidgetView } from 'components/shared';
import Classes from "model";
import React from 'react';
import TASPositivePayViewChecksSearch from "./classes/TASPositivePayViewChecksSearch";
import TASPositivePayViewChecksDesktopFormView from "./components/TASPositivePayViewChecksDesktopFormView";
import TASPositivePayViewChecksMobileFormView from "./components/TASPositivePayViewChecksMobileFormView";
import "./styles.css";
import "./mobile.css";


/**
 * @function TASPositivePayViewChecksPage
 * @return {React.Component}
 * @exported true
 * @description The TAS Positive Pay View Checks page.
 */
export default function TASPositivePayViewChecksPage(props) {
  const context = useBCMSContext();
  BCMSRecord.globalControllerFor(Classes, context);
  const navigate = useRoute();
  const data = { ...getDefaultData(undefined, context), ...props.data ?? {} };
  const ui = { ...getDefaultUI(), ...props.ui ?? {} };

  const controller = (state, setState) => ({
    data: state.data,
    ui: state.ui,

    onAddChecks: () => navigate("/tasPositivePayAddChecks"),

    onChange: prop => val => {
        var _val = val;
        if(prop.includes("Amount")) _val = val.amount;

        // Only allow numbers for the check number inputs.
        /*if(prop.includes("checkNumber")) {
          if(isNaN(val)) {
            return
          } else if(val.includes(".")) {
            return
          }
        }*/

        BCMSStateManagerCRUD.init(state)
        .update([ "data", "search", prop ], _val)
        .submit(setState);
    },

    onClear: () => {
        const search = state.data.search;
        
        BCMSStateManagerCRUD.init(state)
        .update([ "data", "search" ], search.reset())
        .update([ "ui", "didSearch", "isActive" ], false)
        .submit(setState);
    },

    onSearch: () => {
        BCMSStateManagerCRUD.init(state)
        .update([ "ui", "didSearch", "isActive" ], true)
        .submit(setState);
    }
  });

  return (
    <PageContainer className="tas-positive-pay-view-checks-page" state={ { data, ui } } controller={ controller }>
      <PageContent />
    </PageContainer>
  );
}

export const getDefaultData = () => ({
    search: TASPositivePayViewChecksSearch.init(),
});

export const getDefaultUI = () => ({
  accountSelect: { isActive: false },
  didSearch: { isActive: false }
});

function PageContent(props) {
  return (
    <PageContentView>
         <WidgetContainer className="tas-positive-pay-view-checks-widget">
            <WidgetView text="View Checks">
                { <TASPositivePayViewChecksDesktopFormView/> }
                { <TASPositivePayViewChecksMobileFormView/> }
            </WidgetView>
        </WidgetContainer>
    </PageContentView>
  );
}